/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type CrossIconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function CrossIcon(props: CrossIconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 18 18"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "M1.425 18 0 16.575 7.575 9 0 1.425 1.425 0 9 7.575 16.575 0 18 1.425 10.425 9 18 16.575 16.575 18 9 10.425z"
        }
      ></path>
    </svg>
  );
}

export default CrossIcon;
/* prettier-ignore-end */
